/* src/app/shared/menu-popover/menu-popover.component.scss */
ion-item {
  --background: #191919;
  cursor: none;
  display: flex;
  align-items: center;
  row-gap: 10px;
}
ion-item svg,
ion-item ion-icon {
  width: 30px;
  height: 30px;
  fill: white;
  margin-right: 10px;
}
ion-item:hover ion-icon,
ion-item:hover ion-label {
  color: var(--ion-color-secondary) !important;
}
ion-item:hover svg,
ion-item:hover ion-icon {
  fill: var(--ion-color-secondary) !important;
}
ion-item ion-icon,
ion-item svg {
  margin-left: 10px;
}
ion-item:first-of-type {
  margin-top: 15px;
}
ion-item:last-of-type {
  margin-bottom: 15px;
}
ion-icon {
  color: white !important;
  cursor: pointer;
}
ion-label {
  font-family: "League Spartan", sans-serif !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  color: white !important;
  cursor: pointer;
  margin-right: 0;
}
ion-list {
  display: flex;
  flex-direction: column;
  background: #191919;
  row-gap: 10px;
}
/*# sourceMappingURL=menu-popover.component-E3EERJRJ.css.map */
